"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1627,77167,31097],{

/***/ 560327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getBanners; },
/* harmony export */   "Q": function() { return /* binding */ BannerInlinePlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(346115);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167520);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(901550);
/* harmony import */ var _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(603651);






const filterHeightInlineInRootNode = (banners, isMobile) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  let sizePopups = [];
  for (let obj of banners) {
    let content = obj.content;
    for (let key in content) {
      if (content.hasOwnProperty(key)) {
        if (content[key].parentId === "ROOT" && content[key].tag === "inlinebanner" && ((_c = (_b = (_a = content[key]) == null ? void 0 : _a.customAttributes) == null ? void 0 : _b.inlinebanner) == null ? void 0 : _c.relativePosition) === _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ERelativePosition.IN */ .zH.IN) {
          const isPopUpShowInDesktop = !((_g = (_f = (_e = (_d = content[key]) == null ? void 0 : _d.customAttributes) == null ? void 0 : _e.inlinebanner) == null ? void 0 : _f.responsive) == null ? void 0 : _g.hiddenMd);
          const isPopUpShowInMobile = !((_k = (_j = (_i = (_h = content[key]) == null ? void 0 : _h.customAttributes) == null ? void 0 : _i.inlinebanner) == null ? void 0 : _j.responsive) == null ? void 0 : _k.hiddenXs);
          if (isMobile && isPopUpShowInMobile || !isMobile && isPopUpShowInDesktop) {
            sizePopups.push({
              className: content[key].customAttributes.inlinebanner.cssSelector,
              height: (_l = content[key].style.height) != null ? _l : 0,
              width: (_m = content[key].style.width) != null ? _m : 0
            });
          }
        }
      }
    }
  }
  return sizePopups;
};
const getBanners = async ({
  cookies,
  configs,
  env,
  flagsup
}) => {
  const { appId, iamId, trackingAppId, url, isMobile } = configs;
  const parsedCookies = cookie__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Q(cookies);
  const isNewVisitor = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VP */ .CP] !== _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .UNIDENTIFIED */ .eF || parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VS */ .U6] === _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .NEW_USER */ .MB;
  const trackingId = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACKING_ID */ .tz];
  const isMa79Enabled = flagsup.epic_ma_79;
  const handleSubscribe = async () => {
    if (!appId)
      return;
    try {
      const discoveryService = new _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__/* .OnSiteDiscoveryService */ .T(env);
      const body = {
        appId,
        iamId,
        trackingAppId,
        onlyNewVisitor: isNewVisitor,
        url,
        trackingId: isMa79Enabled ? trackingId : void 0
      };
      const banners2 = await discoveryService.subscribeSmartPopup(body);
      return filterHeightInlineInRootNode(banners2, isMobile);
    } catch (e) {
      console.error(e);
    }
  };
  const banners = await handleSubscribe() || [];
  return banners;
};
const BannerInlinePlaceholder = ({
  banners = [],
  className
}) => {
  const matchBanners = banners == null ? void 0 : banners.filter(
    (banner) => banner.className === `.${className}`
  );
  const totalBannerHeight = matchBanners == null ? void 0 : matchBanners.reduce(
    (total, banner) => total + banner.height,
    0
  );
  const maxBannerWidth = matchBanners == null ? void 0 : matchBanners.reduce(
    (max, banner) => Math.max(max, banner.width),
    0
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: matchBanners ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className,
      style: {
        minHeight: `${totalBannerHeight}px`,
        width: `${maxBannerWidth}px`
      }
    }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className
    })
  });
};




/***/ }),

/***/ 346115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ TEMPI_VP; },
/* harmony export */   "GN": function() { return /* binding */ DEFAULT_LIMIT_TIME; },
/* harmony export */   "Hi": function() { return /* binding */ RETURNING; },
/* harmony export */   "J2": function() { return /* binding */ SMART_POPUP_CONFIG; },
/* harmony export */   "MB": function() { return /* binding */ NEW_USER; },
/* harmony export */   "SI": function() { return /* binding */ EXPIRE_MINUTE; },
/* harmony export */   "U6": function() { return /* binding */ TEMPI_VS; },
/* harmony export */   "eF": function() { return /* binding */ UNIDENTIFIED; },
/* harmony export */   "hR": function() { return /* binding */ DEFAULT_DISPLAY_VALUE; },
/* harmony export */   "to": function() { return /* binding */ VIEW_INTERVAL_DURATION; },
/* harmony export */   "tz": function() { return /* binding */ TRACKING_ID; }
/* harmony export */ });
const EXPIRE_MINUTE = 20;
const TEMPI_VP = "_tempi_vp";
const TEMPI_VS = "_tempi_vs";
const SMART_POPUP_CONFIG = "_smart_banner_config";
const NEW_USER = "NEW";
const RETURNING = "RETURNING";
const UNIDENTIFIED = "unidentified";
const VIEW_INTERVAL_DURATION = 100;
const DEFAULT_DISPLAY_VALUE = 1;
const DEFAULT_LIMIT_TIME = 1;
const TRACKING_ID = "_track__track";




/***/ }),

/***/ 603651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OnSiteDiscoveryService; }
/* harmony export */ });
/* harmony import */ var _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(988966);


const onSiteDiscoveryUrl = {
  dev: "https://smart-activation-discovery.dev.tekoapis.net/api",
  stag: "https://smart-activation-discovery.stag.tekoapis.net/api",
  production: "https://smart-activation-discovery.tempi.vn/api"
};
class OnSiteDiscoveryService {
  constructor(env) {
    this.client = new _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__/* .Api */ .V(onSiteDiscoveryUrl[env]);
  }
  async subscribeSmartPopup(params) {
    var _a;
    const { data } = await this.client.post(
      "/v1/smart-activation/subscribe",
      params
    );
    return ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.popups) || [];
  }
}




/***/ }),

/***/ 901550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RW": function() { return /* binding */ ETimeUnit; },
/* harmony export */   "Wv": function() { return /* binding */ EBannerEvent; },
/* harmony export */   "zH": function() { return /* binding */ ERelativePosition; }
/* harmony export */ });
var EBannerEvent = /* @__PURE__ */ ((EBannerEvent2) => {
  EBannerEvent2[EBannerEvent2["DISPLAY"] = 0] = "DISPLAY";
  EBannerEvent2[EBannerEvent2["CLICK"] = 1] = "CLICK";
  EBannerEvent2[EBannerEvent2["CLOSE"] = 2] = "CLOSE";
  return EBannerEvent2;
})(EBannerEvent || {});
var ETimeUnit = /* @__PURE__ */ ((ETimeUnit2) => {
  ETimeUnit2[ETimeUnit2["MINUTE"] = 0] = "MINUTE";
  ETimeUnit2[ETimeUnit2["HOUR"] = 1] = "HOUR";
  ETimeUnit2[ETimeUnit2["SESSION"] = 1] = "SESSION";
  return ETimeUnit2;
})(ETimeUnit || {});
var ERelativePosition = /* @__PURE__ */ ((ERelativePosition2) => {
  ERelativePosition2["BEFORE"] = "before";
  ERelativePosition2["AFTER"] = "after";
  ERelativePosition2["IN"] = "in";
  return ERelativePosition2;
})(ERelativePosition || {});




/***/ }),

/***/ 380822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ s; }
/* harmony export */ });
class s{constructor(s,e,t){this.message=s,this.response=t,this.code=e}get reason(){return this.response}}


/***/ }),

/***/ 988966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83492);
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(opentracing__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380822);
var s=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(t,e,r)=>e in t?s(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,h=(t,e)=>{for(var r in e||(e={}))i.call(e,r)&&p(t,r,e[r]);if(o)for(var r of o(e))c.call(e,r)&&p(t,r,e[r]);return t};const l=(t="",e)=>`${t.endsWith("/")?t.slice(0,t.length-1):t}/${e.startsWith("/")?e.slice(1):e}`;class u{constructor(t,e,r={}){this.baseURL=t,this.interceptors=[],this.getError=e,this.defaultConfig=r}_parseJson(t){return t.text().then((t=>t?JSON.parse(t):null))}addInterceptor(t){this.interceptors.push(t)}appendParamsToURL(t,e={}){if(e){const r=[];for(const t of Object.keys(e))null!==e[t]&&void 0!==e[t]&&r.push(`${t}=${encodeURIComponent(e[t])}`);r.length>0&&(t=`${t}?${r.join("&")}`)}return t}async request(s,o,i,c={}){var p;const{params:u}=c;let f=c.headers||{};const d=this.appendParamsToURL(s,u||{});let g=null;const y=o&&"string"!=typeof o&&"append"in o;o&&"string"!=typeof o&&(y?g=new URLSearchParams(o).toString():(g=JSON.stringify(o),f=h({"Content-Type":"application/json"},f)));let b=null;u&&(b=JSON.stringify(u));const m=(0,opentracing__WEBPACK_IMPORTED_MODULE_0__.globalTracer)(),w=`[${i}] ${l(this.baseURL,s)}`,O=m.startSpan(w);m.inject(O,opentracing__WEBPACK_IMPORTED_MODULE_0__.FORMAT_HTTP_HEADERS,f),O.setTag("http.method",i),O.setTag("http.baseurl",this.baseURL),O.log({body:g,params:b});const j=(P=h({},this.defaultConfig),T={method:i,headers:new Headers(f),body:y?o:g},a(P,n(T)));var P,T;this.interceptors.forEach((t=>t(j)));const E=await fetch(d.startsWith("http")?d:l(this.baseURL,d),j);if(E.status>=400){const t=await E.json(),e=(null==(p=this.getError)?void 0:p.call(this,t))||new _error_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ApiError */ .M("Đã có lỗi xảy ra, vui lòng thử lại sau!",-1,t);return O.setTag("status","error"),O.log({error:JSON.stringify(e)}),O.finish(),Promise.reject(e)}const v={};E.headers.forEach(((t,e)=>v[e]=t));const S=await this._parseJson(E);return O.setTag("status","success"),O.finish(),{code:E.status,data:S,headers:v}}async get(t,e={}){return await this.request(t,null,"GET",e)}async post(t,e,r={}){return await this.request(t,e,"POST",r)}async patch(t,e,r={}){return await this.request(t,e,"PATCH",r)}async put(t,e,r={}){return await this.request(t,e,"PUT",r)}async delete(t,e={},r={}){return await this.request(t,e,"DELETE",r)}}


/***/ }),

/***/ 382725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ index; }
/* harmony export */ });
/* unused harmony exports infinite, unstable_serialize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var STR_UNDEFINED = 'undefined';
var hasWindow = function () { return typeof window != STR_UNDEFINED; };

var IS_SERVER = !hasWindow() || 'Deno' in window;
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
!IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key)
                ? key.length
                : key)
                ? stableHash(key)
                : '';
    var errorKey = key ? '$err$' + key : '';
    var isValidatingKey = key ? '$req$' + key : '';
    return [key, args, errorKey, isValidatingKey];
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

// Create a custom hook with a middleware
var withMiddleware = function (useSWR, middleware) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = normalize(args), key = _a[0], fn = _a[1], config = _a[2];
        var middlewares = (config.use || []).concat(middleware);
        return useSWR(key, fn, __assign(__assign({}, config), { use: middlewares }));
    };
};

// We have to several type castings here because `useSWRInfinite` is a special
var INFINITE_PREFIX = '$inf$';
var getFirstPageKey = function (getKey) {
    return serialize(getKey ? getKey(0, null) : null)[0];
};
var unstable_serialize = function (getKey) {
    return INFINITE_PREFIX + getFirstPageKey(getKey);
};
var infinite = (function (useSWRNext) {
    return function (getKey, fn, config) {
        var rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
        var didMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
        var dataRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
        var cache = config.cache, _a = config.initialSize, initialSize = _a === void 0 ? 1 : _a, _b = config.revalidateAll, revalidateAll = _b === void 0 ? false : _b, _c = config.persistSize, persistSize = _c === void 0 ? false : _c, _d = config.revalidateFirstPage, revalidateFirstPage = _d === void 0 ? true : _d;
        // The serialized key of the first page.
        var firstPageKey = null;
        try {
            firstPageKey = getFirstPageKey(getKey);
        }
        catch (err) {
            // not ready
        }
        // We use cache to pass extra info (context) to fetcher so it can be globally
        // shared. The key of the context data is based on the first page key.
        var contextCacheKey = null;
        // Page size is also cached to share the page data between hooks with the
        // same key.
        var pageSizeCacheKey = null;
        if (firstPageKey) {
            contextCacheKey = '$ctx$' + firstPageKey;
            pageSizeCacheKey = '$len$' + firstPageKey;
        }
        var resolvePageSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
            var cachedPageSize = cache.get(pageSizeCacheKey);
            return isUndefined(cachedPageSize) ? initialSize : cachedPageSize;
            // `cache` isn't allowed to change during the lifecycle
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [pageSizeCacheKey, initialSize]);
        // keep the last page size to restore it with the persistSize option
        var lastPageSizeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(resolvePageSize());
        // When the page key changes, we reset the page size if it's not persisted
        useIsomorphicLayoutEffect(function () {
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (firstPageKey) {
                // If the key has been changed, we keep the current page size if persistSize is enabled
                cache.set(pageSizeCacheKey, persistSize ? lastPageSizeRef.current : initialSize);
            }
            // `initialSize` isn't allowed to change during the lifecycle
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [firstPageKey]);
        // Actual SWR hook to load all pages in one fetcher.
        var swr = useSWRNext(firstPageKey ? INFINITE_PREFIX + firstPageKey : null, function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, forceRevalidateAll, originalData, data, pageSize, previousPageData, i, _b, pageKey, pageArgs, pageData, shouldFetchPage;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = cache.get(contextCacheKey) || [], forceRevalidateAll = _a[0], originalData = _a[1];
                        data = [];
                        pageSize = resolvePageSize();
                        previousPageData = null;
                        i = 0;
                        _c.label = 1;
                    case 1:
                        if (!(i < pageSize)) return [3 /*break*/, 5];
                        _b = serialize(getKey(i, previousPageData)), pageKey = _b[0], pageArgs = _b[1];
                        if (!pageKey) {
                            // `pageKey` is falsy, stop fetching new pages.
                            return [3 /*break*/, 5];
                        }
                        pageData = cache.get(pageKey);
                        shouldFetchPage = revalidateAll ||
                            forceRevalidateAll ||
                            isUndefined(pageData) ||
                            (revalidateFirstPage && !i && !isUndefined(dataRef.current)) ||
                            (originalData &&
                                !isUndefined(originalData[i]) &&
                                !config.compare(originalData[i], pageData));
                        if (!(fn && shouldFetchPage)) return [3 /*break*/, 3];
                        return [4 /*yield*/, fn.apply(void 0, pageArgs)];
                    case 2:
                        pageData = _c.sent();
                        cache.set(pageKey, pageData);
                        _c.label = 3;
                    case 3:
                        data.push(pageData);
                        previousPageData = pageData;
                        _c.label = 4;
                    case 4:
                        ++i;
                        return [3 /*break*/, 1];
                    case 5:
                        // once we executed the data fetching based on the context, clear the context
                        cache.delete(contextCacheKey);
                        // return the data
                        return [2 /*return*/, data];
                }
            });
        }); }, config);
        // update dataRef
        useIsomorphicLayoutEffect(function () {
            dataRef.current = swr.data;
        }, [swr.data]);
        var mutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var data = args[0];
            // Default to true.
            var shouldRevalidate = args[1] !== false;
            // It is possible that the key is still falsy.
            if (!contextCacheKey)
                return;
            if (shouldRevalidate) {
                if (!isUndefined(data)) {
                    // We only revalidate the pages that are changed
                    var originalData = dataRef.current;
                    cache.set(contextCacheKey, [false, originalData]);
                }
                else {
                    // Calling `mutate()`, we revalidate all pages
                    cache.set(contextCacheKey, [true]);
                }
            }
            return args.length ? swr.mutate(data, shouldRevalidate) : swr.mutate();
        }, 
        // swr.mutate is always the same reference
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [contextCacheKey]);
        // Function to load pages data from the cache based on the page size.
        var resolvePagesFromCache = function (pageSize) {
            // return an array of page data
            var data = [];
            var previousPageData = null;
            for (var i = 0; i < pageSize; ++i) {
                var pageKey = serialize(getKey(i, previousPageData))[0];
                // Get the cached page data.
                var pageData = pageKey ? cache.get(pageKey) : UNDEFINED;
                // Return the current data if we can't get it from the cache.
                if (isUndefined(pageData))
                    return dataRef.current;
                data.push(pageData);
                previousPageData = pageData;
            }
            // Return the data
            return data;
        };
        // Extend the SWR API
        var setSize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (arg) {
            // It is possible that the key is still falsy.
            if (!pageSizeCacheKey)
                return;
            var size;
            if (isFunction(arg)) {
                size = arg(resolvePageSize());
            }
            else if (typeof arg == 'number') {
                size = arg;
            }
            if (typeof size != 'number')
                return;
            cache.set(pageSizeCacheKey, size);
            lastPageSizeRef.current = size;
            rerender({});
            return mutate(resolvePagesFromCache(size));
        }, 
        // `cache` and `rerender` isn't allowed to change during the lifecycle
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [pageSizeCacheKey, resolvePageSize, mutate]);
        // Use getter functions to avoid unnecessary re-renders caused by triggering
        // all the getters of the returned swr object.
        return {
            size: resolvePageSize(),
            setSize: setSize,
            mutate: mutate,
            get error() {
                return swr.error;
            },
            get data() {
                return swr.data;
            },
            get isValidating() {
                return swr.isValidating;
            }
        };
    };
});
var index = withMiddleware(swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, infinite);




/***/ }),

/***/ 167520:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ })

}]);